import AmazonLayout from './AmazonLayout';
import NextBigThingsLayout from './NextBigThingsLayout';

export { AmazonLayout, NextBigThingsLayout };
